import { useGetHasScope } from './useGetHasScope';
import { FILE_MANAGER_NO_UPLOAD_LIMIT } from '../../files/constants';
export const useHasNoUploadLimit = () => {
  const getHasScope = useGetHasScope();
  return getHasScope(FILE_MANAGER_NO_UPLOAD_LIMIT);
};